"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeProvider = exports.getSmithyContext = void 0;
var client_1 = require("@smithy/core/client");
Object.defineProperty(exports, "getSmithyContext", { enumerable: true, get: function () { return client_1.getSmithyContext; } });
Object.defineProperty(exports, "normalizeProvider", { enumerable: true, get: function () { return client_1.normalizeProvider; } });
